import script from "./ViewMemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMemoPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewMemoPage.vue?vue&type=style&index=0&id=52de917a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52de917a"]])

export default __exports__